import * as React from 'react';

interface IUseDescriptionLinesProps {
  descriptionRef: React.RefObject<HTMLDivElement>;
  isExpanded: boolean;
  setDescriptionHeight: (height: string | number) => void;
  setNeedReadMore: (arg: boolean) => void;
}

export const CSS_THREE_LINES_HEIGHT = 72;

export const useDescriptionLines = ({
  descriptionRef,
  isExpanded,
  setDescriptionHeight,
  setNeedReadMore,
}: IUseDescriptionLinesProps) => {
  React.useEffect(() => {
    if (isExpanded) {
      setDescriptionHeight('100%');

      return;
    }

    if (descriptionRef && descriptionRef.current && descriptionRef.current.offsetHeight > CSS_THREE_LINES_HEIGHT) {
      setDescriptionHeight(CSS_THREE_LINES_HEIGHT);

      return;
    }
  }, [descriptionRef, isExpanded, setDescriptionHeight]);

  React.useEffect(() => {
    if (descriptionRef && descriptionRef.current) {
      setNeedReadMore(descriptionRef.current.offsetHeight > CSS_THREE_LINES_HEIGHT);
    }
  }, [descriptionRef, setNeedReadMore]);
};
